if(window.innerWidth < 960){
  const showMenu = (e) => {
    dropdown.classList.toggle('active')
    e.preventDefault();
  }

  let dropdown = document.querySelector('.mobile-dropdown')
  let mobileMenu = document.querySelectorAll('.hx-mobile-menu .menu,.mobile-dropdown--close')
  mobileMenu.forEach((item)=>{
    item.addEventListener('click',showMenu)
  })
}